<template>
    <div>
        <a-tooltip title="Transferir para uma mesa">
            <vs-icon
                class="mr-4 cursor-pointer text-danger"
                style="font-size: 32px; position: relative; top: -5px"
                icon-pack="material-icons" 
                icon="reply_all"
                @click="modalTransfer.visible = true" />
        </a-tooltip>

        <a-modal
            :maskClosable="false"
            :width="500"
            :zIndex="80000"
            v-model="modalTransfer.visible"
            :visible="modalTransfer.visible"
            okType="danger"
            okText="Transferir para mesa"
            cancelText="Cancelar"
            title="Transferir para mesa"
            @ok="transferToTable">

            <span>Escolha mesa</span>
            <v-select class="w-full" :options="modalTransfer.tables" :clearable="false" v-model="selectedToTable" />
        </a-modal>
    </div>
</template>

<script>
    import firebase from '@/firebase/firebase'
    import { httpsCallable } from "@/firebase/functions";

    import vSelect from 'vue-select'

    const db = firebase.firestore()

    export default {
        props : {
            billId : {
                type : String,
                required : true
            }
        },

        components : {
            vSelect
        },

        data () {
            return {
                companyId : '',
                selectedToTable : '',
                modalTransfer : {
                    visible : false,
                    tables : []
                }
            }
        },

        mounted () {
            this.getTables()
        },

        methods : {
            async getTables () {
                this.companyId = this.$store.getters.getCompanyID
                const tableSnap = await db.collection(`/company/${this.companyId}/tables`).where('active', '==', true).get()
                const tablesArr = tableSnap.docs.map(table => {
                    return { label : table.data().number, value : table.id }
                }).sort((a,b) => a.label - b.label)
                this.$set(this.modalTransfer, 'tables', tablesArr)
            },

            async transferToTable () {
                try {
                    if(!this.selectedToTable) throw new Error('Selecione uma mesa')

                    this.$vs.loading()
                    const call = httpsCallable('migrateToTable')
                    await call({ companyId : this.companyId, billId : this.billId, tableId : this.selectedToTable.value }) 
                } catch (err) {
                    this.$error({
                        title : 'Erro',
                        content : err.message,
                        zIndex: 999999
                    })
                } finally {
                    this.$vs.loading.close()
                }
            }
        }
    }
</script>